import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-31" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-32" data-mp="1mb3xextzeule">
        <h2 className="text-[1.1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-33" data-mp="1r3ncy0c8bzsu">
          This isn't just another cardiology ebook
        </h2>
        <p className="mt-0.5 font-heading text-[0.74rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.9rem]" data-id="element-34" data-mp="zcr0h0u2zx63">
          It's a ready-to-use visual study system.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-35" data-mp="13g5n4acizbsi">
          {differentiators.map(item => <div key={item.title} className="rounded-md border border-navy/10 bg-ice px-2.5 py-2" data-id="element-36" data-mp="1dc8sdp2obqjo">
              <h3 className="text-[0.76rem] font-extrabold text-navy sm:text-[0.88rem]" data-id="element-37" data-mp="2jsui3i66vnn2">
                <span aria-hidden="true" data-id="element-38" data-mp="2orozqgsf765l">{item.icon}</span> {item.title}
              </h3>
              <p className="mt-0.5 text-[0.74rem] leading-[1.35] sm:text-[0.86rem]" data-id="element-39" data-mp="2otiaa765maiv">{item.body}</p>
            </div>)}
        </div>
        <p className="mt-2 font-heading text-[0.72rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.86rem]" data-id="element-40" data-mp="7mz1sg749vk6">
          Less searching. Less confusion. More visual clarity.
        </p>
      </div>
    </section>;
}